<template>
  <div>
    <!-- Versione Desktop - nascosta su mobile -->
    <div
      v-if="!isLivePage && !useExternalTree"
      class="w-270 flex-shrink-0 hidden md:block sidebar-container h-full overflow-y-auto p-5 space-y-6 pt-44px md:pt-90px"
    >
      <div class="max-w-content mx-auto">
        <SearchBar />
      </div>
      <!-- Header con Promos -->

      <!-- <div class="min-h-35">
      <div
        class="flex items-center space-x-2 text-illinois-text-muted cursor-pointer hover:text-illinois-text transition-colors"
      >
        <SportIcons sport="LHS_Offers2024.svg" />
        <span class="text-md font-bold text-illinois-text">Promos</span>
      </div>
    </div> -->

      <!-- Sezione ANTEPOST -->
      <!-- <div class="">
      <div class="flex items-center space-x-2 min-h-35 align-middle">
        <h3
          class="text-illinois-primary text-base font-medium uppercase font-custom"
        >
          {{ $t('bets.antepost') }}
        </h3>
      </div>
      <div class="space-y-1">
        <div
          v-if="sportsData.antepost && sportsData.antepost.length > 0"
          class=""
        >
          <SidebarItem
            v-for="sport in sportsData.antepost"
            :key="sport.id"
            :sport="sport"
          />
        </div>
        <div v-else>
          <SidebarItem
            v-for="i in 4"
            :key="'antepost-skel-' + i"
            :loading="true"
          />
        </div>
      </div>
    </div> -->

      <!-- Sezione ALL SPORTS -->
      <div class="">
        <div class="flex items-center space-x-2 min-h-35 align-middle">
          <h3
            class="text-illinois-primary text-base font-medium uppercase font-custom"
          >
            {{ $t('allSports') }}
          </h3>
        </div>
        <div class="space-y-1">
          <div v-if="sportsData.allSports && sportsData.allSports.length > 0">
            <SidebarItem
              v-for="sport in sportsData.allSports"
              :key="sport.id"
              :sport="sport"
            />
          </div>
          <div v-else>
            <SidebarItem
              v-for="i in 8"
              :key="'allsports-skel-' + i"
              :loading="true"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Versione Mobile - slide-up dal basso -->
    <div
      v-if="openSportTree && checkIsMobile()"
      class="fixed inset-0 z-500 md:hidden"
      @click.self="closeSidebar"
    >
      <!-- Overlay scuro -->
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <!-- Sidebar mobile con animazione slide-up -->
      <div
        class="absolute inset-0 bg-illinois-darker sidebar-mobile-container"
        :class="{
          'translate-y-0': openSportTree,
          'translate-y-full': !openSportTree
        }"
        @click.stop
      >
        <!-- Header con pulsante di chiusura -->
        <div
          class="sticky top-0 z-10 bg-illinois-darker border-b border-illinois-border px-5 py-4 flex items-center justify-between"
        >
          <h3
            class="text-illinois-primary text-base font-medium uppercase font-custom"
          >
            {{ $t('allSports') }}
          </h3>
          <button
            @click="closeSidebar"
            class="p-2 text-illinois-text-muted hover:text-illinois-primary transition-colors focus:outline-none"
            aria-label="Close"
          >
            <IllinoisIcons icon="close" :width="24" :height="24" />
          </button>
        </div>
        <div class="sidebar-container h-full overflow-y-auto p-5 space-y-6">
          <div class="max-w-content mx-auto">
            <SearchBar />
          </div>
          <!-- Sezione ALL SPORTS -->
          <div class="">
            <div class="space-y-1 pb-70px">
              <div
                v-if="sportsData.allSports && sportsData.allSports.length > 0"
              >
                <div
                  v-for="sport in sportsData.allSports"
                  :key="sport.id"
                  @click="closeSidebar"
                >
                  <SidebarItem :sport="sport" />
                </div>
              </div>
              <div v-else>
                <SidebarItem
                  v-for="i in 8"
                  :key="'allsports-skel-' + i"
                  :loading="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { checkIsMobileDevice } from '@/plugins/device-inspector';
import SidebarItem from './SidebarItem.vue';
import SearchBar from '../Searchbar.vue';
import IllinoisIcons from '../icons.vue';

export default {
  name: 'IllinoisSidebar',
  components: {
    SidebarItem,
    SearchBar,
    IllinoisIcons
  },
  props: {
    sportsData: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      openSportTree: 'IllinoisSport/getOpenSportTree'
    }),
    useExternalTree() {
      return this.$store.getters['uiConfig/fullUIConfig'].useExternalTree;
    },
    isLivePage() {
      return this.$route.path.includes('/live');
    }
  },
  data() {
    return {};
  },
  watch: {
    $route() {
      // Chiudi la sidebar quando cambia la route
      if (this.openSportTree) {
        this.setOpenSportTree(false);
      }
    }
  },
  methods: {
    ...mapActions({
      setOpenSportTree: 'IllinoisSport/setOpenSportTree'
    }),
    checkIsMobile() {
      return checkIsMobileDevice();
    },
    sendCloseMessageToSkin() {
      window.parent.postMessage(
        {
          type: 'statusTreeMenu',
          status: false
        },
        '*'
      );
    },
    closeSidebar() {
      this.sendCloseMessageToSkin();
      this.setOpenSportTree(false);
    },
    onSportSelected(sport) {
      // Chiudi la sidebar quando si seleziona uno sport
      this.setOpenSportTree(false);
      // Emetti evento al parent
      this.$emit('sport-selected', sport);
    },
    getIconPath(iconName) {
      return `/IllinoisIcons/${iconName}`;
    },
    handleImageError(event) {
      // Fallback per icone mancanti
      event.target.src = '/IllinoisIcons/default-sport.svg';
    }
  }
};
</script>

<style scoped>
/* Scrollbar personalizzata - molto sottile */
/* Per Firefox */
.sidebar-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(74, 74, 74, 1) transparent;
  -webkit-overflow-scrolling: touch;
}

/* Per browser WebKit (Chrome, Safari, Edge) */
.sidebar-container::-webkit-scrollbar {
  width: 2px;
}

.sidebar-container::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: rgba(74, 74, 74, 0.3);
  border-radius: 1px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: rgba(85, 85, 85, 0.6);
}

/* Scrollbar ancora più sottile e visibile solo al hover */
.sidebar-container:hover::-webkit-scrollbar {
  width: 3px;
}

.sidebar-container:hover::-webkit-scrollbar-thumb {
  background: rgba(74, 74, 74, 0.5);
}

/* Animazione slide-up per sidebar mobile */
.sidebar-mobile-container {
  transition: transform 0.3s ease-out;
}

.sidebar-mobile-container.translate-y-full {
  transform: translateY(100%);
}

.sidebar-mobile-container.translate-y-0 {
  transform: translateY(0);
}
</style>
